import { startClientSentry } from '../sentry.client.config';

startClientSentry();
